module.exports = __webpack_public_path__ + "img/slider_comments_5.216a6882.jpg";